<template>
    <div>
        <SearchTreeSelectFilter v-bind="filterStaticData.categories"/>
        <SearchSelectFilter v-bind="filterStaticData.flags"/>
        <SearchSelectFilter v-bind="filterStaticData.difficulty_levels"/>
        <SearchSelectFilter v-bind="filterStaticData.instructors"/>
        <SearchSelectFilter v-bind="filterStaticData.authorizations"/>
        <SearchSelectFilter v-bind="filterStaticData.course_types"/>
        <SearchSelectFilter v-bind="filterStaticData.language"/>
        <SearchToggleCompleted />
        <SearchToggleHideDemoContent />
        <slot/>
    </div>
</template>

<script>
    import SearchSelectFilter from 'components/searchable-listing/filters-elements/fields/SearchSelectFilter'
    import SearchTreeSelectFilter from 'components/searchable-listing/filters-elements/fields/SearchTreeSelectFilter'
    import SearchToggleCompleted from 'components/searchable-listing/filters-elements/fields/SearchToggleCompleted'
    import SearchToggleHideDemoContent from 'components/searchable-listing/filters-elements/fields/SearchToggleHideDemoContent'
    import { mapGetters } from 'vuex'

    export default {
        name: 'FilterInputs',
        components: { SearchSelectFilter, SearchTreeSelectFilter, SearchToggleCompleted, SearchToggleHideDemoContent },
        computed: {
            ...mapGetters({
                filterStaticData: 'Search/getFilterStaticData'
            })
        }
    }
</script>
